/**
 * Zustand store for managing paper trading UI state.
 *
 * Phase 3: Chat removed — `chat` page type is gone.
 */

import { create } from 'zustand';

export type ActivePage = 'backtesting' | 'optimizations' | 'configurations' | 'paper-trading' | 'settings' | 'admin-data' | 'admin-activity' | 'terms' | 'privacy' | 'portfolios';

interface PaperTradingStore {
  selectedSessionId: string | null;
  isCreateModalOpen: boolean;
  activePage: ActivePage;

  setSelectedSession: (id: string | null) => void;
  setCreateModalOpen: (open: boolean) => void;
  setActivePage: (page: ActivePage) => void;
  /**
   * Reset to the default (logged-out) state. Called on logout/login (SHA-71)
   * so the previous account's selected session and page don't leak into the
   * next account's session.
   */
  reset: () => void;
}

export const usePaperTradingStore = create<PaperTradingStore>((set) => ({
  selectedSessionId: null,
  isCreateModalOpen: false,
  activePage: 'backtesting',

  setSelectedSession: (id) => set({ selectedSessionId: id }),
  setCreateModalOpen: (open) => set({ isCreateModalOpen: open }),
  setActivePage: (page) => set({ activePage: page }),
  reset: () => set({ selectedSessionId: null, isCreateModalOpen: false, activePage: 'backtesting' }),
}));
